
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Popover, Position } from "@blueprintjs/core";
import classnames from 'classnames';

import logo from '../../resources/logo.png';

import { userLogout } from '../../redux/actions/user.actions';

class Header extends Component {
    onLogout = () => {
        const { userLogout } = this.props;
        userLogout();
    }
    changeRoute = route => {
        const { history, location: { pathname } } = this.props;
        if (pathname !== route) {
            const isReconciliation = this.props.location.pathname.indexOf('/reconciliation') > -1;
            const isDashboard = this.props.location.pathname.indexOf('/dashboard') > -1;
            let routeType;
            if (isReconciliation) {
                routeType = 'reconciliation';
            } else if (isDashboard) {
                routeType = 'dashboard';
            } else {
                routeType = 'donor-search-tool';
            }
            history.push(sessionStorage.getItem(route) ? sessionStorage.getItem(route) : `/${route}`);
            if (pathname !== '/') {
                sessionStorage.setItem(routeType, pathname);
            }
        }
    }
    goBack = () => {
        this.props.history.push('/');
    }
    render() {
        const { pathname } = this.props.location;
        const { user: { isAuthenticated, data }} = this.props;
        const isReconciliation = pathname.indexOf('/reconciliation') > -1;
        const isDashboard = pathname.indexOf('/dashboard') > -1 || pathname === '/';
        const isDonorSearchTool = pathname.indexOf('/donor-search-tool') > -1;
        return (
            <nav className="pt-navbar">
                <div className="pt-navbar-group pt-align-left" style={{ cursor: 'pointer' }} onClick={this.goBack} >
                    <img alt="MEF logo" src={logo} height="40px"/>
                    <div className="pt-navbar-heading">
                        Missions Education Fund
                    </div>
                </div>
                { isAuthenticated && pathname !== '/' ?
                    <div className="pt-navbar-group pt-align-right">
                        <button style={{marginRight: 10}} className={classnames('pt-button pt-minimal pt-icon-grid-view', { 'selected': isDashboard })} onClick={() => this.changeRoute('dashboard')}>Dashboard</button>
                        <button style={{marginRight: 10}} className={classnames('pt-button pt-minimal pt-icon-people',  { 'selected': isReconciliation})} onClick={() => this.changeRoute('reconciliation')}>Reconciliation</button>
                        { data.is_super_admin || data.is_corporate_admin ?
                            <button className={classnames('pt-button pt-minimal pt-icon-search',  { 'selected': isDonorSearchTool})} onClick={() => this.changeRoute('donor-search-tool')}>Donor Search Tool</button>
                            : null
                        }
                        <span className="pt-navbar-divider"></span>
                        { false ? <button className="pt-button pt-minimal pt-icon-user" /> : null }
                        <Popover
                            position={Position.BOTTOM_RIGHT}
                            content={<Settings onLogout={this.onLogout}/>}>
                            <button className="pt-button pt-minimal pt-icon-cog" />
                        </Popover>
                    </div> : null
                }
                { pathname === '/' ?
                    <div className="pt-navbar-group pt-align-right">
                        <div className="admin-button" onClick={() => this.props.history.push('/dashboard')}>
                            Admin Portal
                        </div>
                    </div> : null
                }
            </nav>
        );
    }
}

class Settings extends Component {
    render() {
        const { onLogout } = this.props;
        return (
            <div className="header-settings">
                <button onClick={() => onLogout()} className="pt-button pt-minimal pt-icon-log-out">Logout</button>
            </div>
        );
    }
}
const mapStateToProps = (state, ownProps) => ({
    user: state.user
});
const mapDispatch = {
    userLogout
};
export default withRouter(connect(
    mapStateToProps,
    mapDispatch
)(Header));



// WEBPACK FOOTER //
// ./src/components/main/Header.jsx